import {
  api_url,
  legendLabelsBoxHeightLine,
  configChartsColorPalettes,
  yRight,
  partSumpTrajectory,
  popupInformation,
  defaultBarPercentage,
  defaultDatalabelsProperties,
  defaultTicksCustomValue,
} from "../../../utils";

const EmissionPm = {
  checked: false,
  titleSideBar: "Emisiones de PM2,5",
  titleIndicator: "SUMP Trajectory Content.charts.EmissionPm.title",
  popupInformation: {
    status: "false",
    text: popupInformation[partSumpTrajectory]["emissionPm"],
  },
  keyFigure: {
    typeUpdate: "year", // year or geographical_area
    label: "",
    url: "",
    separator: "",
    position: "",
  },
  charts: [
    {
      typeChart: "area",
      typeLabels: "geographical_areas", // years or geographical_areas
      multiYearGeographicalArea: true,
      singleYearGeographicalAreaType: "geographical_area", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
      titleChart: "",
      titleDisplay: "true",
      legendDisplay: "true",
      legendCustom: "false",
      legendLabelsBoxHeight: legendLabelsBoxHeightLine,
      maintainAspectRatio: true,
      indexAxis: "x", // x or y
      heightChart: "350",
      widthChart: "600",
      i18nKeyLabels: "SUMP Trajectory Content.charts.EmissionPm.axis.labelsX",
      scales: {
        x: {
          type: "category",
          display: true,
          stacked: true,
          titleDisplay: false,
          titleText: "",
          gridDisplay: false,
          beginAtZero: false,
          ticks: {
            display: true,
            value: defaultTicksCustomValue,
          },
        },
        y: {
          type: "linear",
          display: true,
          stacked: true,
          titleDisplay: true,
          titleText: "SUMP Trajectory Content.charts.EmissionPm.axis.titleY",
          gridDisplay: true,
          beginAtZero: true,
          max: 100,
          ticks: {
            display: true,
            value: defaultTicksCustomValue,
          },
        },
        yRight: yRight,
      },
      annotationsProperties: {
        annotation1: undefined,
        annotation2: undefined,
      },
      keyFigure: {
        typeUpdate: "year", // year or geographical_area
        label: "",
        url: "",
        separator: "",
        position: "",
      },
      datasets: [
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionPm.legend.HIDETOOLTIPIFZEROAutos",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_pm&trend=projection&chart=emission_pm_autos&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes["trajectory_emission_pm"]
              .backgroundColor[1],
          borderColor:
            configChartsColorPalettes["trajectory_emission_pm"].borderColor[1],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionPm.legend.HIDETOOLTIPIFZEROMotos",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_pm&trend=projection&chart=emission_pm_motos&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes["trajectory_emission_pm"]
              .backgroundColor[2],
          borderColor:
            configChartsColorPalettes["trajectory_emission_pm"].borderColor[2],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionPm.legend.HIDETOOLTIPIFZEROTaxis",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_pm&trend=projection&chart=emission_pm_taxis&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes["trajectory_emission_pm"]
              .backgroundColor[0],
          borderColor:
            configChartsColorPalettes["trajectory_emission_pm"].borderColor[0],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionPm.legend.HIDETOOLTIPIFZEROBus convencional",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_pm&trend=projection&chart=emission_pm_bus_convencional&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes["trajectory_emission_pm"]
              .backgroundColor[3],
          borderColor:
            configChartsColorPalettes["trajectory_emission_pm"].borderColor[3],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionPm.legend.HIDETOOLTIPIFZEROBRT eléctrico",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_pm&trend=projection&chart=emission_pm_brt_electrico&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes["trajectory_emission_pm"]
              .backgroundColor[4],
          borderColor:
            configChartsColorPalettes["trajectory_emission_pm"].borderColor[4],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionPm.legend.HIDELEGENDHIDETOOLTIPIFZEROAutos",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_pm&trend=projection&chart=emission_pm_autos_objective&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_emission_pm_objective_transparency"
            ].backgroundColor[1],
          borderColor:
            configChartsColorPalettes[
              "trajectory_emission_pm_objective_transparency"
            ].borderColor[1],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionPm.legend.HIDELEGENDHIDETOOLTIPIFZEROMotos",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_pm&trend=projection&chart=emission_pm_motos_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_emission_pm_objective_transparency"
            ].backgroundColor[2],
          borderColor:
            configChartsColorPalettes[
              "trajectory_emission_pm_objective_transparency"
            ].borderColor[2],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionPm.legend.HIDELEGENDHIDETOOLTIPIFZEROTaxis",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_pm&trend=projection&chart=emission_pm_taxis_objective&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_emission_pm_objective_transparency"
            ].backgroundColor[0],
          borderColor:
            configChartsColorPalettes[
              "trajectory_emission_pm_objective_transparency"
            ].borderColor[0],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionPm.legend.HIDELEGENDHIDETOOLTIPIFZEROBus convencional",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_pm&trend=projection&chart=emission_pm_bus_convencional_objective&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_emission_pm_objective_transparency"
            ].backgroundColor[3],
          borderColor:
            configChartsColorPalettes[
              "trajectory_emission_pm_objective_transparency"
            ].borderColor[3],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionPm.legend.HIDELEGENDHIDETOOLTIPIFZEROBRT eléctrico",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_pm&trend=projection&chart=emission_pm_brt_electrico_objective&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_emission_pm_objective_transparency"
            ].backgroundColor[4],
          borderColor:
            configChartsColorPalettes[
              "trajectory_emission_pm_objective_transparency"
            ].borderColor[4],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
      ],
    },
  ],
};

export default EmissionPm;
